import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  root: {
    padding: spacing(0, 3, 3),
    '& .MuiGrid-item': {
      '& .MuiGrid-container:nth-child(2)': {
        gap: spacing(3)
      }
    }
  }
}))
